module.exports = __webpack_public_path__ + "static/media/rogue.dab15e9d.jpg";